// Third Party Plugins
import React, { FC } from 'react';
// Types
import { FormInputProps } from './types';
// Styles
import {
  StyledCheckbox,
  StyledErrorMessage,
  StyledInput,
  StyledInputGroup,
  StyledLabel,
  StyledTextarea,
} from './styles';

const FormInput: FC<FormInputProps> = ({
  label,
  id,
  register,
  isTextarea = false,
  rows,
  cols,
  type = 'text',
  placeholder,
  errors,
}) => {
  if (type === `checkbox`) {
    return (
      <StyledCheckbox>
        <input id={id} type={type} {...register(id)} />
        <label htmlFor={id}>{label}</label>
      </StyledCheckbox>
    );
  }

  return (
    <StyledInputGroup>
      <StyledLabel htmlFor={id}>{label}</StyledLabel>
      {isTextarea ? (
        <StyledTextarea
          id={id}
          rows={rows}
          cols={cols}
          placeholder={placeholder}
          aria-invalid={errors && errors[id] ? `true` : `false`}
          {...register(id, { required: 'This field is required.' })}
        />
      ) : (
        <StyledInput
          id={id}
          type={type}
          placeholder={placeholder}
          aria-invalid={errors && errors[id] ? `true` : `false`}
          {...register(id, { required: 'This field is required.' })}
        />
      )}

      {errors && errors[id]?.type === `required` && (
        <StyledErrorMessage role="alert">
          {String(errors[id]?.message)}
        </StyledErrorMessage>
      )}
    </StyledInputGroup>
  );
};

export default FormInput;
